<!-- 设备管理-生产列表-出库 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea Output">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 步骤条 -->
      <el-steps :active="active.step" finish-status="success" align-center>
        <el-step title="分配企业"></el-step>
        <el-step title="确认配置信息"></el-step>
      </el-steps>

      <!-- 步骤1 分配企业 -->
      <div class="step1" v-if="active.step === 0">
        <!-- 表单 -->
        <el-form
          class="step1Form clearfix"
          label-position="right"
          label-width="140px"
          :model="outputData"
          :rules="rules"
          ref="step1Form"
        >
        <p class="forTit">设备参数</p>
          <el-form-item label="设置类型：" prop="device_id">
            <el-select
              class="step1Input"
              placeholder="请选择设备类型"
              v-model="outputData.device_id"
              @focus="getDeviceList"
              :disabled="$route.query.device_id!=='0'"
              @change="outputData.brand_id = '' && getDeviceDataList"
              clearable>
              <el-option-group
                v-for="group in deviceList"
                :key="group.device_id"
                :label="group.name">
                <el-option
                  v-for="item in group.children"
                  :key="item.device_id"
                  :label="item.name"
                  :value="item.device_id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>

          <el-form-item label="设备品牌：" prop="brand_id">
            <el-select
              class="step1Input"
              placeholder="请选择设备品牌"
              v-model="outputData.brand_id"
              @focus="getDeviceDataList"
              :disabled="$route.query.device_id !== '0'"
              clearable
            >
                <el-option
                  v-for="item in deviceDataList.brand"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              
            </el-select>
          </el-form-item>

          <el-form-item label="通讯方式：" prop="com_type">
            <el-select
              class="step1Input"
              placeholder="请选择通讯方式"
              v-model="outputData.com_type"
              filterable
              clearable
            >
              <el-option
                v-for="item in comTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="固件版本：" prop="firmware_version">
            <el-input class="step1Input" v-model="outputData.firmware_version" placeholder="可为空"></el-input>
          </el-form-item> -->

          
          <el-form-item
            label="其他平台设备id："
            prop="card_no"
          >
            <el-input
              class="step1Input"
              v-model="outputData.card_no"
              placeholder="可为空"
              clearable
            ></el-input>
          </el-form-item>

          <p class="forTit">配置地址参数</p>
          <!-- <el-form-item label="地址类型：" prop="app_config_type">
            <el-select
              class="step1Input"
              placeholder="请选择地址类型"
              v-model="outputData.app_config_type"
              filterable
              clearable
              @focus="getAppConfig">
              <el-option
                v-for="item in appConfigList"
                :key="item.index"
                :label="item.name"
                :value="item.index">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="地址名称：" prop="server_env_id">
            <el-select
              class="step1Input"
              placeholder="请选择地址名称"
              v-model="outputData.server_env_id"
              @focus="getServerEnvList"
              @change="getActiveServerEnv"
              filterable
              clearable
            >
              <el-option
                v-for="item in appConfigTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-popover
              placement="right-end"
              width="auto"
              trigger="hover"
              v-if="outputData.server_env_id !== ''"
            >
              <div class="appInfoBox">
                <div class="row">
                  <span class="label">通讯地址：</span>
                  <span class="value">{{
                    server_env.mqtt_host === "" ? "/" : server_env.mqtt_host
                  }}</span>
                </div>
                <div class="row">
                  <span class="label">4.0业务地址：</span>
                  <span class="value">{{
                    server_env.api_host_v4 === "" ? "/" : server_env.api_host_v4
                  }}</span>
                </div>
                <div class="row">
                  <span class="label">wms业务地址：</span>
                  <span class="value">{{
                    server_env.api_host_wms === ""
                      ? "/"
                      : server_env.api_host_wms
                  }}</span>
                </div>
                <div class="row">
                  <span class="label">4.0s业务地址：</span>
                  <span class="value">{{
                    server_env.api_host_v4s === ""
                      ? "/"
                      : server_env.api_host_v4s
                  }}</span>
                </div>
              </div>
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="连接方式：" prop="server_type">
            <el-select
              class="step1Input"
              placeholder="请选择连接方式"
              v-model="outputData.server_type"
              filterable
              clearable
            >
              <el-option
                v-for="item in serverTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="服务器地址：" prop="server_address">
            <el-input
              class="step1Input"
              v-model="outputData.server_address"
              placeholder="可为空"
              clearable
            ></el-input>
          </el-form-item>

          <p class="forTit">分配对象</p>
          <el-form-item label="服务器组：" prop="server_category_id">
            <el-select
              class="step1Input"
              placeholder="请选择服务器组"
              v-model="outputData.server_category_id"
              @focus="getServerCategoryList"
              @change="serverGroupChange"
              filterable
              clearable
            >
              <el-option
                v-for="item in serverGroupList"
                :key="item.category_id"
                :label="item.name"
                :value="item.category_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="代理商名称：" prop="company_id" :rules="{ required: activeServerGroup.is_internal === '1', message: '请选择服务商名称', trigger: 'change' }"> -->
          <el-form-item
            label="代理商名称："
            prop="company_id"
            v-if="
              !(
                platformDType === 'geeku' &&
                activeServerGroup.network_type === '2'
              )
            "
          >
            <el-select
              class="step1Input"
              placeholder="请选择企业"
              v-model="outputData.company_id"
              @focus="getCompanyList"
              filterable
              clearable
            >
              <el-option
                v-for="item in companyList"
                :key="item.company_id"
                :label="item.company_name"
                :value="item.company_id"
              >
              </el-option>
            </el-select>
            <span class="hint"
              >该服务器组为内网部署，此出库操作只做记录，需要在该服务器组重复操作才算真正出库</span
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submitForm1('step1Form')">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 步骤2 确认配置信息 -->
      <div class="step2" v-if="active.step === 1">
        <!-- （类型 1柜类 2门禁 3机器人） -->
        <!-- 柜类 -->
        <div class="cabinets" v-if="active.device_type == '1'">
          <!-- 添加按钮 -->
          <el-button class="addBtn" @click="operateDialogInfo('cabinets')"
            >添 加</el-button
          >

          <!-- 柜类列表 -->
          <el-table
            class="cabinetsList"
            :data="cabinetTableData"
            style="width: 60%"
            :cell-style="setCellStyle"
            :header-cell-style="setCellStyle"
            border
          >
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column prop="box_number" label="编号"> </el-table-column>
            <el-table-column prop="type" label="类型"> </el-table-column>
            <el-table-column prop="box_size" label="大小"> </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="operateDialogInfo('cabinetsDelete', scope)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <!-- 按钮区域 -->
          <div class="btnArea">
            <el-button class="prev" @click="prev">上一步</el-button>
            <el-button class="save" @click="saveCabinetInfo">保存</el-button>
          </div>
        </div>

        <!-- 门禁 -->
        <div class="doors" v-else-if="active.device_type == '2'">
          <!-- 添加按钮 -->
          <!-- <el-button class="addBtn" @click="operateDialogInfo('doors')">添 加</el-button> -->

          <!-- 门禁列表 -->
          <el-table
            class="doorsList"
            :data="doorTableData"
            style="width: 80%"
            :cell-style="setCellStyle"
            :header-cell-style="setCellStyle"
            border
          >
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column prop="device_no_id" label="设备ID" width="120">
            </el-table-column>
            <el-table-column label="子设备ID" width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.child_device_no_id"
                  placeholder="允许为空"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="device_type_name" label="类型" width="80">
            </el-table-column>
            <el-table-column label="叠加红外传感">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.add_node"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="说明">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.box_desc"
                  placeholder="允许为空"
                ></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="operateDialogInfo('doorsDelete', scope)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>

          <!-- 按钮区域 -->
          <div class="btnArea">
            <el-button class="prev" @click="prev">上一步</el-button>
            <el-button class="save" @click="saveDoorInfo">保存</el-button>
          </div>
        </div>

        <!-- 机器人 -->
        <div
          class="robot"
          v-else-if="
            active.device_type == '3' ||
              active.device_type == '4' ||
              active.device_type == '5' ||
              active.device_type == '6'
          "
        >
          <!-- 表单 -->
          <el-form
            class="robotForm clearfix"
            label-position="right"
            label-width="100px"
          >
            <p class="forTit">设备参数</p>
            <el-form-item label="设置类型：">
              <p class="text">{{ formData.use }}</p>
            </el-form-item>
            
            <el-form-item label="设备品牌：">
              <p class="text">{{ active.brand_name }}</p>
            </el-form-item>

            <!-- <el-form-item label="固件版本：">
              <p class="text">{{outputData.firmware_version === '' ? '/' : outputData.firmware_version}}</p>
          </el-form-item> -->
            <el-form-item label="通讯方式：">
              <p class="text">{{ formData.com_type_name }}</p>
            </el-form-item>
            <el-form-item label="卡号：" v-if="outputData.com_type == 4">
              <p class="text">{{ outputData.card_no }}</p>
            </el-form-item>

            <p class="forTit">配置地址参数</p>
            <!-- <el-form-item label="地址类型：">
              <p class="text">{{outputData.app_config_type === '' ? '/' : formData.app_config_type_name}}</p>
            </el-form-item> -->
            <el-form-item label="地址名称：">
              <p class="text">{{ formData.app_config_name }}</p>
            </el-form-item>
            <el-form-item label="连接方式：">
              <p class="text">{{ formData.server_type_name }}</p>
            </el-form-item>
            <el-form-item label="服务器地址：">
              <p class="text">
                {{
                  outputData.server_address == ""
                    ? "/"
                    : outputData.server_address
                }}
              </p>
            </el-form-item>

            <p class="forTit">分配对象</p>
            <el-form-item label="服务器组：">
              <p class="text">{{ formData.server_group_name }}</p>
            </el-form-item>
            <el-form-item label="代理商名称：">
              <p class="text">
                {{ outputData.company_id === "" ? "/" : formData.company_name }}
              </p>
            </el-form-item>
          </el-form>
          <!-- 按钮区域 -->
          <div class="btnArea">
            <el-button class="prev" @click="prev">上一步</el-button>
            <el-button class="save" @click="saveRobotInfo">保存</el-button>
          </div>
        </div>

        <!-- 其他 -->
        <div class="" v-else>
          开发中...
          <!-- 按钮区域 -->
          <div class="btnArea">
            <el-button class="prev" @click="prev">上一步</el-button>
            <!-- <el-button class="save">保存</el-button> -->
          </div>
        </div>
      </div>

      <!--对话框-->
      <el-dialog
        :title="dialogData.title"
        :visible.sync="dialogData.visible"
        :show-close="dialogData.title === '' ? false : true"
      >
        <!-- 柜类添加信息 -->
        <div v-if="dialogData.type === 'cabinets'">
          <el-form label-width="100px">
            <el-form-item label="类型:">
              <div class="inputBox clearfix">
                <el-input
                  class="inputDeposit"
                  v-model="dialogData.info.device_type_name"
                  :readonly="true"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="箱格数量:">
              <div class="inputBox clearfix">
                <el-input
                  class="inputDeposit number"
                  v-model="dialogData.info.number"
                ></el-input>
                个
              </div>
            </el-form-item>
            <el-form-item
              v-for="(item, index) in dialogData.info.box"
              :key="item.box_type"
              :label="item.box_name"
              @click="clickFormItem(index)"
            >
              <div class="inputBox clearfix">
                <el-input class="inputSmall" v-model="item.number"></el-input>
                <span class="unit">个</span>
                <el-input
                  class="inputSmall"
                  placeholder="开始编号"
                  v-model="item.minNo"
                  @input="minInputChange"
                  @blur="minInputBlur"
                ></el-input>
                <span class="symbol">~</span>
                <el-input
                  class="inputSmall"
                  placeholder="结束编号"
                  v-model="item.maxNo"
                  @input="maxInputChange"
                  @blur="maxInputBlur"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmCabinet()"
              >确 认</el-button
            >
          </div>
        </div>

        <!-- 门禁添加信息 -->
        <div v-if="dialogData.type === 'doors'">
          <el-form label-width="100px">
            <!-- <el-form-item label="类型:">
                <div class="inputBox clearfix">
                  <el-input class="inputDeposit" v-model="dialogData.info.device_type_name" :readonly="true"></el-input>
                </div>
              </el-form-item> -->
            <el-form-item label="数量:">
              <div class="inputBox clearfix">
                <el-input
                  class="inputDeposit number"
                  v-model="dialogData.info.number"
                ></el-input>
                个
              </div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmDoors()">确 认</el-button>
          </div>
        </div>

        <!-- 删除 -->
        <div
          class="changeStatusWrapper"
          v-else-if="
            dialogData.type === 'cabinetsDelete' ||
              dialogData.type === 'doorsDelete'
          "
        >
          <!-- 批量删除 -->
          <p class="text">
            确认删除所选信息？
          </p>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogData.visible = false">否</el-button>
            <!-- 删除id -->
            <!-- 柜类删除 -->
            <el-button
              @click="deleteLi('cabinets')"
              v-if="dialogData.type === 'cabinetsDelete'"
              >是</el-button
            >
            <!-- 门禁删除 -->
            <el-button
              @click="deleteLi('doors')"
              v-if="dialogData.type === 'doorsDelete'"
              >是</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../../Layout/BreadCrumb.vue";
import {
  showToast,
  isRepeat,
  localUserInfo
} from "../../../../../static/js/utility/utility.js";
import { getNowDate } from "../../../../../static/js/utility/date.js";
import {
  systemApi,
  deviceApi,
  maintainApi
} from "../../../../../static/js/api.js";
import store from "../../../../store";
let vm;

export default {
  name: "Output",
  components: {
    BreadCrumb
  },
  data() {
    return {
      platformDType: localUserInfo.getItem().platform_deploy_type,
      // 对话框数据
      dialogData: {
        type: "",
        title: "",
        visible: false,
        info: {}
      },
      // 当前显示步骤、选中设备分类（类型 1柜类 2门禁 3机器人）
      active: {
        step: 0,
        device_type: "",
        brand_name: "",
      },

      rules: {
        device_id: [
          { required: true, message: "请选择设备类型", trigger: "change" }
        ],
        com_type: [
          { required: true, message: "请选择通讯地址", trigger: "change" }
        ],
        // card_no: [{ required: true, message: "请输入卡号", trigger: "blur" }],
        server_env_id: [
          { required: true, message: "请选择地址名称", trigger: "change" }
        ],
        server_type: [
          { required: true, message: "请选择连接地址", trigger: "change" }
        ],
        server_category_id: [
          { required: true, message: "请选择服务组", trigger: "change" }
        ],
        company_id: [
          { required: true, message: "请选择服务商名称", trigger: "change" }
        ]
      },
      // 出库数据
      outputData: {
        device_no_id: [],
        device_id: "", // 设备类型
        // firmware_version: '', // 固件版本
        com_type: "", // 通讯方式
        card_no: "", // nb卡的卡号
        // app_config_type: '', // 地址类型
        server_env_id: "", // 地址名称id
        server_type: "", // 通讯地址，即连接地址
        server_address: "", // 服务器地址
        server_category_id: "", // 服务器组id
        company_id: "", // 代理商id
        number: "",
        // 柜类专有出库数据
        box: [],
        //设置品牌id
        brand_id: "",
      },
      comTypeList: [
        // 设备参数-通讯方式列表：1-有线，2-4g，3-wifi，4nb卡
        {
          label: "有线",
          value: "1"
        },
        {
          label: "4g",
          value: "2"
        },
        {
          label: "wifi",
          value: "3"
        },
        {
          label: "nb卡",
          value: "4"
        }
      ],
      appConfigList: [], // 地址参数设置-地址列表
      appConfigTypeList: [], // 地址参数设置-地址类型列表
      server_env: {},
      serverTypeList: [
        // 地址参数设置-连接地址列表： 0未设置 1mqtt 2中转 3、4.0S
        {
          label: "mqtt",
          value: "1"
        },
        {
          label: "中转",
          value: "2"
        },
        {
          label: "4.0s",
          value: "3"
        },
        {
          label: "外部连接",
          value: "4"
        }
      ],
      // 服务器组列表
      serverGroupList: [],
      activeServerGroup: {},
      // 公司列表
      companyList: [],
      // 设备列表（类型 1柜类 2门禁 3机器人）
      deviceList: [],
      /* 步骤2表格数据 */
      // 柜类
      cabinetTableData: [],
      // 门禁
      doorTableData: [],

      formData: {
        brand_id: ""
      },

      boxActiveIndex: 0,
      isConfirm: true,
      noArr: [],
      //设备品牌特性列表
      deviceDataList: {
        brand: []
      },
      
    };
  },
  created() {
    vm = this;
    console.log("vm.platformDType", vm.platformDType);
  },
  mounted() {
    // 获取需要出库的设备id
    // console.log('device_no_id', vm.$route.query.device_no_id)
    vm.outputData.device_no_id = vm.$route.query.device_no_id;
    if (this.$route.query.device_id !== "0") {
      this.outputData.device_id = this.$route.query.device_id;
      this.getDeviceList();
    }
  },
  methods: {
    // 操作对话框信息（添加或修改）dialogData
    operateDialogInfo: function(type, info) {
      console.log("type", type);
      let device_type_name = vm.active.device_type_name;
      // 柜类添加信息
      let cabinetInfo = {
        device_type_name: device_type_name,
        number: "",
        box: [
          {
            box_name: "A(极大):",
            box_size: "A",
            number: "",
            maxNo: "",
            minNo: ""
          },
          {
            box_name: "B(大):",
            box_size: "B",
            number: "",
            maxNo: "",
            minNo: ""
          },
          {
            box_name: "C(中):",
            box_size: "C",
            number: "",
            maxNo: "",
            minNo: ""
          },
          {
            box_name: "D(小):",
            box_size: "D",
            number: "",
            maxNo: "",
            minNo: ""
          },
          {
            box_name: "E(极小):",
            box_size: "E",
            number: "",
            maxNo: "",
            minNo: ""
          }
        ]
      };
      // 门禁添加信息
      let doorInfo = {
        device_type_name: device_type_name,
        number: ""
      };

      let title = "添加";
      vm.dialogData = {
        type: type,
        title: title,
        visible: !vm.dialogData.visible,
        info:
          type === "cabinets" ? cabinetInfo : type === "doors" ? doorInfo : info
      };
      // console.log('vm', vm.dialogData)
    },
    // 获取地址参数列表
    async getServerEnvList() {
      let res = await systemApi.getServerEnvList();
      if (res.meta.code === 200) {
        vm.appConfigTypeList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },
    // 获取当前选中的地址名称信息
    getActiveServerEnv() {
      let id = vm.outputData.server_env_id;
      if (id === "" || id === undefined) {
        return;
      }
      vm.appConfigTypeList.forEach((item, i) => {
        if (item.id === id) {
          vm.server_env = item;
        }
      });
    },
    // 获取平板地址参数配置
    async getAppConfig() {
      let res = await deviceApi.getAppConfig();
      if (res.meta.code === 200) {
        let list = res.data;
        res.data.forEach((item, i) => {
          list[i].index = i;
        });
        vm.appConfigList = list;
      } else {
        showToast(res.meta.message);
      }
    },
    clickFormItem(index) {
      console.log("index", index);
    },
    // 柜类input输入框值变化
    minInputChange(val) {
      console.log("val", val);
      vm.dialogData.info.box.forEach((item, index) => {
        if (item.minNo == val) {
          console.log("index::", index);
          vm.boxActiveIndex = index;
        }
      });
    },
    minInputBlur() {
      let maxval = vm.dialogData.info.box[vm.boxActiveIndex].maxNo;
      let minval = vm.dialogData.info.box[vm.boxActiveIndex].minNo;
      let number = vm.dialogData.info.box[vm.boxActiveIndex].number;
      vm.isConfirm = true;
      console.log(
        maxval - minval + 1,
        "maxval",
        maxval,
        "minval",
        minval,
        "number",
        number
      );
      if (maxval - minval + 1 != number && maxval != "") {
        showToast("箱格编号范围与分配数量不符");
        vm.isConfirm = false;
        vm.dialogData.info.box[vm.boxActiveIndex].minNo = "";
        return;
      }
      vm.cabinetTableData.forEach(function(item, index) {
        if (item.box_number == minval) {
          showToast(minval + "号箱格已添加，请重新输入");
          vm.dialogData.info.box[vm.boxActiveIndex].minNo = "";
          return;
        }
      });
      // vm.noArr.forEach(function (item, index) {
      //   if (item == minval) {
      //     showToast(minval + '号箱格已存在，请重新输入')
      //     vm.dialogData.info.box[vm.boxActiveIndex].minNo = ''
      //     return
      //   }
      // })
    },
    maxInputChange(val) {
      console.log("val", val);
      vm.dialogData.info.box.forEach((item, index) => {
        if (item.maxNo == val) {
          console.log("index::", index);
          vm.boxActiveIndex = index;
        }
      });
    },
    maxInputBlur() {
      let maxval = vm.dialogData.info.box[vm.boxActiveIndex].maxNo;
      let minval = vm.dialogData.info.box[vm.boxActiveIndex].minNo;
      let number = vm.dialogData.info.box[vm.boxActiveIndex].number;
      vm.isConfirm = true;
      console.log(
        maxval - minval + 1,
        "maxval",
        maxval,
        "minval",
        minval,
        "number",
        number
      );
      if (maxval - minval + 1 != number && minval != "") {
        showToast("箱格编号范围与分配数量不符");
        vm.isConfirm = false;
        vm.dialogData.info.box[vm.boxActiveIndex].maxNo = "";
        return;
      }
      vm.cabinetTableData.forEach(function(item, index) {
        if (item.box_number == maxval) {
          showToast(val + "号箱格已添加，请重新输入");
          vm.dialogData.info.box[vm.boxActiveIndex].maxNo = "";
          return;
        }
      });
      console.log("noArr", vm.noArr);
    },
    // 获取服务器组列表
    getServerCategoryList: async function() {
      let res = await maintainApi.getServerCategoryListOut();
      if (res.meta.code === 200) {
        vm.serverGroupList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },
    // 获取当前选中的服务器组
    serverGroupChange(e) {
      // console.log('e', e)
      vm.outputData.company_id = "";
      vm.companyList = [];
      vm.serverGroupList.forEach((item, i) => {
        if (item.category_id === e) {
          vm.activeServerGroup = item;
        }
      });
    },

    /* 门禁相关操作 */
    // 门禁类确认添加信息
    confirmDoors: function() {
      // 重置数据
      vm.doorTableData = [];
      // 当有门禁数量时
      let number = vm.outputData.device_no_id.length;
      // console.log('门禁数量number', number)

      // 获取门禁信息列表
      for (let j = 0; j < number; j++) {
        vm.doorTableData.push({
          device_no_id: vm.outputData.device_no_id[j],
          box_number: j + 1,
          type: "门禁",
          device_type_name: vm.outputData.device_type_name,
          child_device_no_id: "",
          box_desc: "",
          add_node: false
        });
      }
      // console.log('vm.doorTableData', vm.doorTableData)
    },
    // 保存，确认门禁类出库
    saveDoorInfo: function() {
      let box = vm.doorTableData;
      vm.outputData.number = box.length;
      // 是否写了子设备id
      let iswrite = false;

      for (let i in box) {
        // 判断
        if (box[i].child_device_no_id != "") {
          iswrite = true;
        }
        // if (box[i].box_desc === '') {
        //   showToast('请填写说明')
        //   return
        // }
        vm.outputData.box[i] = {
          device_no_id: vm.outputData.device_no_id[i],
          box_number: box[i].box_number,
          type: box[i].type,
          child_device_no_id: box[i].child_device_no_id,
          box_desc: box[i].box_desc,
          add_node: box[i].add_node ? 1 : 0
        };
        // console.log('vm.outputData.box[i]', vm.outputData.box[i])
      }
      // console.log('tag', vm.outputData)
      // return
      // 判断不能有重复的子设备id
      if (iswrite) {
        if (isRepeat(box, "child_device_no_id")) {
          showToast("不能有相同的子设备ID！");
          return;
        }
      }

      // 强制刷新vue没有更新的数组
      vm.outputData.box.splice(box.length);
      // console.log('box', box)
      // console.log('vm.outputData', vm.outputData)

      // return
      // 保存确认出库
      vm.outStock(vm.outputData);
    },

    /* 柜类相关操作 */
    // 柜类确认添加信息
    confirmCabinet: function() {
      let box = vm.dialogData.info.box;

      // console.log('box', box)
      let boxSum = 0;
      // 获取dialog要生成的箱格数量
      for (let i in box) {
        // console.log('box[i]', box[i])
        // 当有箱格数量时
        let number = box[i].number === "" ? 0 : parseInt(box[i].number);
        // console.log('箱格数量number', number)
        boxSum = boxSum + number;
      }
      // 箱格数量不符
      // console.log('boxSum', boxSum)
      if (boxSum !== parseInt(vm.dialogData.info.number)) {
        showToast("分配的箱格数是" + (boxSum === "" ? "0" : boxSum) + "个");
        return;
      }

      // 获取箱格信息列表
      // vm.cabinetTableData =  []
      for (let i in box) {
        // console.log('box[i]', box[i])
        // 当有箱格数量时
        let number = box[i].number === "" ? 0 : parseInt(box[i].number);
        // console.log('箱格数量number', number)

        // 获取箱格信息列表
        if (number !== 0) {
          // console.log('i', i)
          let minNo = box[i].minNo;
          let maxNo = box[i].maxNo;
          if (minNo === "") {
            showToast("请设置" + box[i].box_size + "的开始编号！");
            return;
          }
          if (isNaN(parseInt(minNo)) || isNaN(parseInt(maxNo))) {
            showToast("编号只能为数字");
            return;
          }
          for (let j = 0; j < number; j++) {
            // console.log('box_number', minNo++)
            vm.cabinetTableData.push({
              box_number: minNo++,
              type: vm.dialogData.info.device_type_name,
              box_size: box[i].box_size
            });
          }
        }
      }

      if (!vm.isConfirm) {
        return;
      }
      // 隐藏对话框
      vm.dialogData.visible = !vm.dialogData.visible;
      console.log("vm.cabinetTableData", vm.cabinetTableData);
    },
    // 保存，确认柜类出库
    saveCabinetInfo: function() {
      let box = vm.cabinetTableData;
      vm.outputData.number = box.length;
      // console.log('box', box)
      for (let i in box) {
        vm.outputData.box[i] = {
          box_size: box[i].box_size,
          box_number: box[i].box_number
        };
        // console.log('vm.outputData.box[i]', vm.outputData.box[i])
      }
      // console.log('vm.cabinetTableData', vm.cabinetTableData)
      // console.log('vm.outputData', vm.outputData)
      // console.log('vm.outputData.box', vm.outputData.box)

      // 判断
      if (isRepeat(box, "box_number")) {
        showToast("不能有相同的编号！");
        return;
      }
      // console.log('vm.isRepeat(box)', vm.isRepeat(box))

      // 强制刷新vue没有更新的数组
      vm.outputData.box.splice(box.length);
      // 保存确认出库
      vm.outStock(vm.outputData);
    },

    /* 机器人相关操作 */
    confirmRobot() {
      /** 设备参数 */
      // 获取设备类型
      vm.deviceList.forEach(item => {
        if (item.children) {
          item.children.forEach(cItem => {
            if (cItem.device_id === vm.outputData.device_id) {
              vm.formData.use = cItem.name;
            }
          });
        }
      });
      // 获取设备参数
      vm.comTypeList.forEach(item => {
        if (item.value === vm.outputData.com_type) {
          vm.formData.com_type_name = item.label;
        }
      });
      /** 配置地址参数 */
      // 获取地址名称
      vm.appConfigTypeList.forEach(cItem => {
        if (cItem.id === vm.outputData.server_env_id) {
          vm.formData.app_config_name = cItem.name;
        }
      });
      // 获取连接方式（通讯方式）
      vm.serverTypeList.forEach(item => {
        if (item.value === vm.outputData.server_type) {
          vm.formData.server_type_name = item.label;
        }
      });

      /** */
      // 获取已选择服务器组名称
      vm.serverGroupList.forEach(item => {
        if (item.category_id === vm.outputData.server_category_id) {
          vm.formData.server_group_name = item.name;
        }
      });
      // 获取已选择企业名称
      vm.companyList.forEach(item => {
        if (item.company_id === vm.outputData.company_id) {
          vm.formData.company_name = item.company_name;
        }
      });
      console.log("vm.formData", vm.formData);
    },

    // 保存，确认机器人出库
    saveRobotInfo() {
      // 保存确认出库
      vm.outStock(vm.outputData);
    },

    /* 公共操作 */
    // 删除表格信息
    deleteLi: function(type) {
      let index = vm.dialogData.info.$index;
      // 柜类表格删除信息
      if (type === "cabinets") {
        vm.cabinetTableData.splice(index, 1);
        // console.log('vm.cabinetTableData', vm.cabinetTableData)
      } else if (type === "doors") {
        vm.doorTableData.splice(index, 1);
        // console.log('vm.doorTableData', vm.doorTableData)
      }

      vm.$forceUpdate();
      // 删除成功提示
      showToast("删除成功");
      // 隐藏对话框
      vm.dialogData.visible = !vm.dialogData.visible;
    },

    // 出库/批量出库
    outStock: async function(data) {
      // 删除不必要的字段
      delete data.device_type_name;
      console.log("data", data);
      // return
      let res = await deviceApi.outStock(data);
      if (res.meta.code === 200) {
        showToast("出库成功");
        setTimeout(function() {
          // 出库成功后，返回生产列表显示tab
          vm.$store.state.outputSuccessShowTab = "hasOutput";
          vm.back();
        }, 1000);
      } else {
        showToast(res.meta.message);
      }
    },

    // 设置单元格样式(表头和序号那一列)
    setCellStyle: function({ row, column, rowIndex, columnIndex }) {
      // console.log('row', row)
      // console.log('column', column)
      // console.log('rowIndex', rowIndex)
      // console.log('columnIndex', columnIndex)
      if ((!row.box_number && rowIndex === 0) || columnIndex === 0) {
        return { backgroundColor: "#F5F7FA" };
      } else {
        return {};
      }
    },
    // 下一步
    submitForm1(formName) {
      vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.next();
        } else {
          return false;
        }
      });
    },

    next() {
      // 判断步骤1表格数据
      let outputData = vm.outputData;
      console.log("vm.outputData", vm.outputData.server_address);
      // return

      // 表格1数据验证ok，获取当前选中的一级类型和类型名称
      let active_device_id = vm.outputData.device_id;
      let deviceList = vm.deviceList;
      for (let i in deviceList) {
        for (let j in deviceList[i].children) {
          if (active_device_id === deviceList[i].children[j].device_id) {
            // console.log('deviceList[i].name', deviceList[i].name, deviceList[i].type)
            vm.active.device_type = deviceList[i].type;
            vm.active.device_type_name = deviceList[i].children[j].name;
            vm.outputData.device_type_name = deviceList[i].children[j].name;
          }
        }
      }

      for (let item of this.deviceDataList.brand) {
        if (item.id == this.outputData.brand_id) {
          this.active.brand_name = item.name;
        }
      }

      console.log("active::::", vm.active);
      // 门禁确认设备列表
      if (vm.active.device_type === "2") {
        vm.confirmDoors();
      }
      // 执行下一步
      if (vm.active.step++ > 2) {
        vm.active.step = 0;
      }
    },

    // 上一步
    prev() {
      if (vm.active.step-- < 0) vm.active.step = 0;
    },
    // 取消
    cancel() {
      vm.$store.state.outputSuccessShowTab = "hasStorage";
      vm.back();
    },
    // 返回上一页
    back: function() {
      vm.$router.go(-1);
    },
    // 获取公司列表
    getCompanyList: async function() {
      vm.companyList = [];
      let data = {
        search_str: "",
        server_category_id: vm.outputData.server_category_id
      };

      let res = await deviceApi.getCompanyList(data);
      if (res.meta.code === 200) {
        vm.companyList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

    // 获取设备列表
    getDeviceList: async function() {
      let data = {};
      if (this.$route.query.device_id !== "0") {
        data.device_id = this.$route.query.device_id;
      }
      let res = await maintainApi.getDeviceList(data);
      if (res.meta.code === 200) {
        vm.deviceList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

    //设备品牌等数据列表
    getDeviceDataList: async function() {
      let data = {};
      data.device_id = this.outputData.device_id;
      let res = await systemApi.getAllDataList(data);
      if (res.meta.code === 200) {
        vm.deviceDataList = res.data;
      } else {
        showToast(res.meta.message);
      }
    },

  },
  watch: {
    // 地址参数设置-地址类型变化时
    "outputData.app_config_type"(newVal) {
      // console.log('newVal', newVal)
      vm.outputData.server_env_id = "";
      vm.appConfigTypeList =
        newVal === "" ? [] : vm.appConfigList[newVal].children;
    },

    // 监听当前执行步骤的值变化
    "active.step": function(newVal) {
      // console.log('newVal', newVal)
      if ((newVal = 2 && vm.active.device_type === "3")) {
        vm.confirmRobot();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Output {
  .el-steps {
    padding-bottom: 24px;
    margin-bottom: 30px;
    border-bottom: 1px solid #cccccc;
  }
  .step1Form,
  .robotForm {
    .forTit {
      font-weight: bold;
      margin-bottom: 12px;
    }
    .el-form-item {
      // height: 40px;
      .step1Input {
        width: 260px;
      }
    }
  }
  .step2 {
    .cabinets .cabinetsList,
    .doors .doorsList {
      margin: 20px 0;
    }
  }
  .inputBox {
    width: 345px;
    .inputDeposit.number {
      width: 300px;
      float: left;
      margin-right: 20px;
    }
    .inputSmall {
      width: 90px;
      float: left;
    }
    .unit,
    .symbol {
      float: left;
      margin: 0 10px;
    }
    .unit {
      margin-right: 20px;
    }
  }
  .hint {
    color: #f56c6c;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProductList/Output.vue